export var HTTP_STATUS;
(function (HTTP_STATUS) {
    HTTP_STATUS[HTTP_STATUS["OK"] = 200] = "OK";
    HTTP_STATUS[HTTP_STATUS["CREATED"] = 201] = "CREATED";
    HTTP_STATUS[HTTP_STATUS["ACCEPTED"] = 202] = "ACCEPTED";
    HTTP_STATUS[HTTP_STATUS["NO_CONTENT"] = 204] = "NO_CONTENT";
    HTTP_STATUS[HTTP_STATUS["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HTTP_STATUS[HTTP_STATUS["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTP_STATUS[HTTP_STATUS["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTP_STATUS[HTTP_STATUS["NOT_FOUND"] = 404] = "NOT_FOUND";
    HTTP_STATUS[HTTP_STATUS["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HTTP_STATUS[HTTP_STATUS["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HTTP_STATUS[HTTP_STATUS["CONFLICT"] = 409] = "CONFLICT";
    HTTP_STATUS[HTTP_STATUS["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HTTP_STATUS[HTTP_STATUS["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HTTP_STATUS[HTTP_STATUS["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HTTP_STATUS[HTTP_STATUS["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HTTP_STATUS[HTTP_STATUS["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
})(HTTP_STATUS || (HTTP_STATUS = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["ACCESS_TOKEN"] = "access_token";
    StorageKey["API_URL"] = "api_url";
    StorageKey["COMPLETED_USER_PHASE_EVENTS"] = "completed_user_phase_events";
    StorageKey["CURRENT_QUEUE_PAGE"] = "current_queue_page";
    StorageKey["INVITE_CODE"] = "invite_code";
    StorageKey["UMOTIF_CODE"] = "umotif_code";
    StorageKey["REFRESH_TOKEN"] = "refresh_token";
})(StorageKey || (StorageKey = {}));
export var BroadcastEventType;
(function (BroadcastEventType) {
    BroadcastEventType["ACTIVITY"] = "activity";
    BroadcastEventType["LOGOUT"] = "logout";
})(BroadcastEventType || (BroadcastEventType = {}));
export const QuestionnaireEntryMode = {
    RETROSPECTIVE: 'retrospective',
    STANDARD: 'standard'
};
export var UrlParamsKey;
(function (UrlParamsKey) {
    UrlParamsKey["CODE"] = "code";
    UrlParamsKey["EVENT_ID"] = "event_id";
    UrlParamsKey["EVENT_TYPE"] = "event_type";
    UrlParamsKey["ENTRY_MODE"] = "entry_mode";
    UrlParamsKey["INVITATION_CODE"] = "invitation_code";
    UrlParamsKey["STATE"] = "state";
    UrlParamsKey["STARTED_AT"] = "started_at";
    UrlParamsKey["STUDY_CODE"] = "study_code";
    UrlParamsKey["SUBMITTED_AT"] = "submitted_at";
    UrlParamsKey["SUBMITTED_AT_TIMEZONE"] = "submitted_at_timezone";
    UrlParamsKey["SUBMITTED_BY"] = "submitted_by";
    UrlParamsKey["SUBMITTED_FOR"] = "submitted_for";
    UrlParamsKey["SEGMENT_ORIGINATOR_ID"] = "segment_originator_id";
    UrlParamsKey["SEGMENT_ORIGINATOR_TYPE"] = "segment_originator_type";
    UrlParamsKey["TOKEN"] = "token";
    UrlParamsKey["REPORT_ITEM_ID"] = "report_item_id";
    UrlParamsKey["REPORT_ITEM_TYPE"] = "report_item_type";
})(UrlParamsKey || (UrlParamsKey = {}));
export var APIHeaderKey;
(function (APIHeaderKey) {
    APIHeaderKey["ACCEPT_LANGUAGE"] = "Accept-Language";
    APIHeaderKey["CONTENT_TYPE"] = "Content-Type";
    APIHeaderKey["DATETIME"] = "DateTime";
    APIHeaderKey["LOCALE"] = "X-UMOTIF-LOCALE";
    APIHeaderKey["TIMEZONE"] = "X-UMOTIF-TIMEZONE";
})(APIHeaderKey || (APIHeaderKey = {}));
export var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["AFRIKAANS"] = "af";
    LANGUAGE["AFRIKAANS_ZA"] = "af-ZA";
    LANGUAGE["ARABIC"] = "ar-AE";
    LANGUAGE["ARMENIAN"] = "hy-AM";
    LANGUAGE["BELARUSIAN"] = "be-BY";
    LANGUAGE["BENGALI"] = "bn";
    LANGUAGE["BENGALI_BD"] = "bn-BD";
    LANGUAGE["BENGALI_IN"] = "bn-IN";
    LANGUAGE["BOSNIAN"] = "bs-BA";
    LANGUAGE["BULGARIAN"] = "bg-BG";
    LANGUAGE["CATALAN"] = "ca-ES";
    LANGUAGE["CHINESE"] = "zh-CN";
    LANGUAGE["CHINESE_HK"] = "zh-HK";
    LANGUAGE["CHINESE_SG"] = "zh-SG";
    LANGUAGE["CHINESE_TW"] = "zh-TW";
    LANGUAGE["CZECH"] = "cs-CZ";
    LANGUAGE["DANISH"] = "da-DK";
    LANGUAGE["DUTCH"] = "nl-NL";
    LANGUAGE["ENGLISH_GB"] = "en-GB";
    LANGUAGE["ENGLISH_US"] = "en-US";
    LANGUAGE["ENGLISH_SG"] = "en-SG";
    LANGUAGE["ENGLISH_ZA"] = "en-ZA";
    LANGUAGE["ESTONIAN"] = "et-ET";
    LANGUAGE["BASQUE"] = "eu-ES";
    LANGUAGE["FINNISH"] = "fi-FI";
    LANGUAGE["FRENCH"] = "fr-FR";
    LANGUAGE["GEORGIAN"] = "ka-GE";
    LANGUAGE["GERMAN"] = "de-DE";
    LANGUAGE["GREEK"] = "el-GR";
    LANGUAGE["GUJARATI"] = "gu";
    LANGUAGE["GUJARATI_IN"] = "gu-IN";
    LANGUAGE["HEBREW"] = "he-IL";
    LANGUAGE["HINDI"] = "hi-IN";
    LANGUAGE["CROATIAN"] = "hr-HR";
    LANGUAGE["HUNGARIAN"] = "hu-HU";
    LANGUAGE["INDONESIAN"] = "id-ID";
    LANGUAGE["ICELANDIC"] = "is-IS";
    LANGUAGE["ITALIAN"] = "it-IT";
    LANGUAGE["JAPANESE"] = "ja-JP";
    LANGUAGE["KAZAKH"] = "kk";
    LANGUAGE["KAZAKH_KZ"] = "kk-KZ";
    LANGUAGE["KOREAN"] = "ko-KO";
    LANGUAGE["LATIN"] = "sr-RS";
    LANGUAGE["LATVIAN"] = "lv-LV";
    LANGUAGE["LITHUANIAN"] = "lt-LT";
    LANGUAGE["MACEDONIAN"] = "mk-MK";
    LANGUAGE["MALAY"] = "ms";
    LANGUAGE["MALAY_MY"] = "ms-MY";
    LANGUAGE["MALAY_SG"] = "ms-SG";
    LANGUAGE["MALTESE"] = "mt-MT";
    LANGUAGE["MONTENEGRIN"] = "me-ME";
    LANGUAGE["MONGOLIAN"] = "mn-MN";
    LANGUAGE["NORWEGIAN"] = "nb-NO";
    LANGUAGE["PANJABI_IN"] = "pa-IN";
    LANGUAGE["PANJABI_PK"] = "pa-PK";
    LANGUAGE["POLISH"] = "pl-PL";
    LANGUAGE["PORTUGUESE"] = "pt-BR";
    LANGUAGE["PORTUGUESE_PT"] = "pt-PT";
    LANGUAGE["ROMANIAN"] = "ro-RO";
    LANGUAGE["RUSSIAN"] = "ru-RU";
    LANGUAGE["SLOVAK"] = "sk-SK";
    LANGUAGE["SPANISH"] = "es-ES";
    LANGUAGE["ALBANIAN"] = "sq-AL";
    LANGUAGE["SWAHILI"] = "sw";
    LANGUAGE["SWAHILI_KE"] = "sw-KE";
    LANGUAGE["SWEDISH"] = "sv-SE";
    LANGUAGE["TAMIL_IN"] = "ta-IN";
    LANGUAGE["TAMIL_SG"] = "ta-SG";
    LANGUAGE["TELUGU"] = "te";
    LANGUAGE["TELUGU_IN"] = "te-IN";
    LANGUAGE["THAI"] = "th";
    LANGUAGE["THAI_TH"] = "th-TH";
    LANGUAGE["TAGALOG"] = "tl-PH";
    LANGUAGE["TSWANA"] = "tn-ZA";
    LANGUAGE["TURKISH"] = "tr-TR";
    LANGUAGE["UKRAINIAN"] = "uk-UA";
    LANGUAGE["URDU_IN"] = "ur-IN";
    LANGUAGE["URDU_PK"] = "ur-PK";
    LANGUAGE["UZBEK"] = "uz";
    LANGUAGE["VIETNAMESE"] = "vi";
    LANGUAGE["VIETNAMESE_VN"] = "vi-VN";
    LANGUAGE["XHOSA"] = "xh-ZA";
    LANGUAGE["ZULU"] = "zu";
    LANGUAGE["ZULU_ZA"] = "zu-ZA";
})(LANGUAGE || (LANGUAGE = {}));
export var DataTest;
(function (DataTest) {
    // BLOCKS
    DataTest["BLOCK_ERRORS"] = "block-errors";
    DataTest["VERTICAL_SCALE_BOTTOM_LABEL"] = "vertical-scale-bottom-label";
    DataTest["VERTICAL_SCALE_TOP_LABEL"] = "vertical-scale-top-label";
    DataTest["VISUAL_ANALOGUE_SCALE_START_LABEL"] = "visual-analogue-scale-start-label";
    DataTest["VISUAL_ANALOGUE_SCALE_END_LABEL"] = "visual-analogue-scale-end-label";
    DataTest["NUMERICAL_RATING_SCALE_LABEL"] = "numerical-rating-scale-label";
    // BREADCRUMB
    DataTest["BREADCRUMB"] = "breadcrumb";
    // HEADER
    DataTest["HEADER_PORTAL_NAME"] = "portal-name";
    // NOT FOUND
    DataTest["NOT_FOUND_HOME_LINK"] = "home-link";
    // PROFILE
    DataTest["PROFILE_LOGOUT"] = "logout";
    // SPINNER
    DataTest["SPINNER"] = "spinner";
    // UNSUPPORTED
    DataTest["UNSUPPORTED_SMART_BANNER"] = "smart-banner";
    // QUESTIONNAIRE
    DataTest["QUESTIONNAIRE_CTA"] = "questionnaire-cta";
    DataTest["QUESTIONNAIRE_NAV_BACKWARD"] = "questionnaire-nav-backward";
    DataTest["QUESTIONNAIRE_NAV_FORWARD"] = "questionnaire-nav-forward";
    DataTest["QUESTIONNAIRE_ERROR_OCCURRED"] = "questionnaire-error-occurred";
    DataTest["QUESTIONNAIRE_LOAD_PARTIAL_MODAL_NO"] = "questionnaire-load-partial-modal-no";
    DataTest["QUESTIONNAIRE_LOAD_PARTIAL_MODAL_YES"] = "questionnaire-load-partial-modal-yes";
    // TOOLS
    DataTest["TOOLS_TIME_WARP"] = "tools-time-warp";
    // LIGHT REPORT
    DataTest["LIGHT_REPORT_EMPTY_MESSAGE"] = "light-report-empty-message";
    DataTest["LIGHT_REPORT_ITEM"] = "light-report-item";
    DataTest["LIGHT_REPORT_ITEM_HEADER"] = "light-report-item-header";
    DataTest["LIGHT_REPORT_DETAIL"] = "light-report-detail";
    DataTest["LIGHT_REPORT_PAGINATION"] = "light-report-pagination";
    DataTest["LIGHT_REPORT_PAGINATION_DISPLAY"] = "light-report-pagination-display";
    DataTest["LIGHT_REPORT_PAGINATION_NEXT"] = "light-report-pagination-next";
    DataTest["LIGHT_REPORT_PAGINATION_PREVIOUS"] = "light-report-pagination-previous";
    // WAYFINDER
    DataTest["WAYFINDER_SIDEBAR"] = "wayfinder-sidebar";
    DataTest["WAYFINDER_SECTION"] = "wayfinder-section";
    // REGISTRATION
    DataTest["REGISTER_NEXT"] = "register-next";
    DataTest["REGISTER_PREV"] = "register-prev";
    DataTest["REGISTER_SUBMIT"] = "register-submit";
    DataTest["REGISTER_BACKGROUND"] = "register-background";
    // LANGUAGE SELECTION
    DataTest["LANGUAGE_SELECTION_NEXT"] = "language-selection-next";
    DataTest["LANGUAGE_SELECTION_CONFIRM"] = "language-selection-confirm";
    DataTest["LANGUAGE_SELECTION_CANCEL"] = "language-selection-cancel";
    // EVENT LIST ITEM
    DataTest["EVENT_LIST_ITEM"] = "event-list-item";
    // SCHEDULE
    DataTest["SCHEDULE_HEADER"] = "schedule-header";
    DataTest["STATE_MESSAGING"] = "state-messaging";
    DataTest["STATE_MESSAGING_BLOCK"] = "state-messaging-block";
    // MODAL
    DataTest["MODAL_BASE"] = "modal-base";
    DataTest["MODAL_TITLE"] = "modal-title";
    DataTest["MODAL_CONTENT"] = "modal-content";
    DataTest["MODAL_FOOTER"] = "modal-footer";
    DataTest["MODAL_BODY"] = "modal-body";
    // PAYMENT SETUP
    DataTest["PAYMENT_SETUP_TC_CHECKBOX"] = "payment-setup-tc-checkbox";
    DataTest["PAYMENT_SETUP_TC_LINK"] = "payment-setup-tc-link";
    DataTest["PAYMENT_SETUP_SUBMIT"] = "payment-setup-submit";
    // MOBILE MENU
    DataTest["MOBILE_MENU_TOGGLE"] = "mobile-menu-toggle-button";
    DataTest["MOBILE_MENU_LEAF"] = "mobile-menu-leaf";
    DataTest["MOBILE_MENU_ITEM"] = "mobile-menu-item";
    DataTest["MOBILE_MENU_CATEGORY"] = "mobile-menu-category";
    DataTest["MOBILE_MENU_SIGN_OUT_CONFIRM"] = "mobile-menu-sign-out-confirm";
    DataTest["MOBILE_MENU_SIGN_OUT_CANCEL"] = "mobile-menu-sign-out-cancel";
    DataTest["MOBILE_MENU_SIGN_OUT_LEAF"] = "mobile-menu-sign-out-leaf";
    DataTest["MOBILE_MENU_DIALOG_LEAF"] = "mobile-menu-dialog-leaf";
    DataTest["MOBILE_MENU_DIALOG_CLOSE"] = "mobile-menu-dialog-close";
    DataTest["MOBILE_MENU_DRAWER"] = "mobile-menu-drawer";
})(DataTest || (DataTest = {}));
export var MessageType;
(function (MessageType) {
    MessageType["QB_PREVIEW"] = "qb:preview";
    MessageType["QB_RESET"] = "qb:reset";
})(MessageType || (MessageType = {}));
export var BroadcastChannelType;
(function (BroadcastChannelType) {
    BroadcastChannelType["CLINRO"] = "clinro";
    BroadcastChannelType["CLINRO_AUTH"] = "clinro-auth";
    BroadcastChannelType["INACTIVITY_SYNC"] = "inactivity_sync";
    BroadcastChannelType["QUESTIONNAIRE"] = "questionnaire_channel";
})(BroadcastChannelType || (BroadcastChannelType = {}));
